import { formatDate } from "@angular/common";
import { FilterOption } from "@models/grid/grid-filter";
import { RelationshipType, RelationshipTypeLabels } from "@models/relationships/relationship-type.enum";
import { RelationshipIndividualDto } from "@models/individuals/relationship-individual-dto";

export const relationshipsFilterOptions: FilterOption[] = [
  RelationshipType.Agent,
  RelationshipType.Director,
  RelationshipType.Secretary,
  RelationshipType.AlternativeDirector,
  RelationshipType.Securityholder,
  RelationshipType.Beneficiary,
  RelationshipType.Trustee,
  RelationshipType.Appointor,
  RelationshipType.Settlor,
  RelationshipType.Successor,
  RelationshipType.PublicOfficer
].map((relationshipType) => ({
  label: RelationshipTypeLabels[relationshipType],
  value: relationshipType.toString(),
  active: false
}));

export function getRelationshipDatesFilterOptions(relationships: RelationshipIndividualDto[]): FilterOption[] {
  return relationships
    .filter((relationship) => relationship.individualDataOverride?.dob)
    .map((relationship) => relationship.individualDataOverride?.dob)
    .map((dob) => ({
      label: formatDate(dob ?? '', 'dd MMM yyyy', 'en'),
      value: dob ?? '',
      active: false
    }));
}

export function getRelationshipsContactNicknamesFilterOptions(relationships: RelationshipIndividualDto[]): FilterOption[] {
  const allNicknames = relationships
    .filter((relationship) => relationship.contact?.nickname?.trim())
    .map((relationship) => relationship.contact!.nickname);

  return new Array(...new Set(allNicknames))
    .map((nickname) => ({
      label: nickname,
      value: nickname,
      active: false
    }));
}
